import styled from 'styled-components'

const Container = styled.div.attrs(({ width, height, x, y, background }) => ({
  style: {
    width: `${width}px`,
    height: `${height}px`,
    left: `${x}px`,
    top: `${y}px`,
    background: `${background}`
  }
}))`
  ${({ width, height }) => `
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  &.solid:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: ${width}px;
    height: ${height}px;
    background: repeating-linear-gradient(
      45deg,
      transparent,
      transparent 3px,
      rgba(255,255,255,0.125) 3px,
      rgba(255,255,255,0.125) 6px
    );
  }
`}
`

export const Tile = ({ background, children, solid, position, ...rest }) => {
  return (
    <Container
      {...position}
      className={solid ? 'solid' : ''}
      background={background}
    >
      {children}
    </Container>
  )
}
